import * as React from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'
import { FormikProps } from 'formik'

import { observer } from 'mobx-react'

import DurationInput from 'modules/core/components/DurationInput'
import i18n from 'modules/core/lib/i18n'

import { BreakSettingsFormValues } from 'modules/attendance/lib/forms/BreakSettingForm'

import DurationRules from './DurationRules'
import type RuleForm from './DurationRules/form'
import type DurationRuleForm from './DurationRules/form'

interface Props {
  settingForm: FormikProps<BreakSettingsFormValues>
  durationRuleForms: RuleForm[]
  onConfirm: () => void
  addRule: () => void
  deleteRule: (form: DurationRuleForm) => void
  hasCorrectiveBreaksFeature: boolean
}

const ManualBreakSettings = ({
  settingForm,
  durationRuleForms,
  addRule,
  deleteRule,
  onConfirm,
  hasCorrectiveBreaksFeature,
}: Props) => {
  const baseMinimalDuration = settingForm.values.baseMinimalDuration || 0
  const showSaveButton =
    !hasCorrectiveBreaksFeature &&
    (settingForm.dirty || durationRuleForms.some((form) => form.isDirty))

  const handleBaseMinimalDuration = (minutes: number) => {
    settingForm.setFieldValue('baseMinimalDuration', minutes)
  }

  return (
    <Box gap="s16">
      <Box gap="s6">
        <Box flexDirection="row" maxWidth="s140">
          <DurationInput
            label={i18n.t('time_tracking.settings.breaks.instance.min_break_duration.label')}
            minutes={baseMinimalDuration}
            onChange={handleBaseMinimalDuration}
          />
        </Box>
        <Text size="200">
          {i18n.t('time_tracking.settings.breaks.instance.min_break_duration.description')}
        </Text>
      </Box>
      <Box
        border={{
          bottom: {
            color: 'grey400',
            width: 's2',
            style: 'solid',
          },
        }}
      ></Box>
      <Box gap="s6">
        <DurationRules
          durationRuleForms={durationRuleForms}
          addRule={addRule}
          deleteRule={deleteRule}
        />
        <Text size="200">
          {i18n.t('time_tracking.settings.breaks.instance.duration_rules.description')}
        </Text>
      </Box>
      {showSaveButton && (
        <Box flexDirection="row" justifyContent="flexStart">
          <Button type="primary" onClick={onConfirm} iconName="save">
            {i18n.t('common.save_changes')}
          </Button>
        </Box>
      )}
    </Box>
  )
}

export default observer(ManualBreakSettings)
